import firebase from "firebase";

export const fetchIndex = async (projectId) => {
  const querySnapshot = await  firebase.firestore()
      .collection('projects')
      .doc(projectId)
      .collection('reports')
      .orderBy('index', 'desc').limit(1)
      .get();

  let result = null

  querySnapshot.forEach((data) => {
    result = Number(data.data().index) + 1;
  });

  return result;
}


export const fetchReport = async (projectId, reportId) => {
  return firebase.firestore()
    .collection('projects')
    .doc(projectId)
    .collection('reports')
    .doc(reportId)
    .get()
};

export const copyReport = async (id, projectId, index) => {
  const response = await fetchReport(projectId, id)
  const report = {...response.data()};
  const ref = await firebase.firestore()
    .collection('projects')
    .doc(projectId)
    .collection('reports')
    .add({
      ...report,
      from: null,
      index
    })

  return {
    id: ref.id,
    index
  };
}


export const copyChild = async (reportData, projectId) => {
  const modifyReportData = {...reportData};

  if(reportData.reportPROF) {
    let index =  await fetchIndex(projectId)

    const responseId = await copyReport(reportData.reportPROF, projectId, index)
    modifyReportData.reportPROF = responseId.id;
    modifyReportData.PROF = {
      ...modifyReportData.PROF,
      index: index
    };
  }

  if(reportData.reportTECH) {
    let index =  await fetchIndex(projectId)
    const responseId = await copyReport(reportData.reportTECH, projectId, index)
    modifyReportData.reportTECH = responseId.id;
    modifyReportData.TECH = {
      ...modifyReportData.TECH,
      index: index
    };
  }

  modifyReportData.index = await fetchIndex(projectId)
  modifyReportData.is_temp = true;
  return modifyReportData;
}

export const updateFrom = async (projectId, reportData, from) => {
  if(reportData.reportPROF) {
    console.log(reportData, from, projectId, 'reportData')
    await firebase.firestore()
      .collection('projects')
      .doc(projectId)
      .collection('reports').doc(reportData.reportPROF)
      .update({
        from: from.id
      })
  }

  if(reportData.reportTECH) {
    console.log(reportData, from, projectId, 'reportData')
    await firebase.firestore()
      .collection('projects')
      .doc(projectId)
      .collection('reports')
      .doc(reportData.reportTECH)
      .update({
        from: from.id
      })
  }
}



// WEBPACK FOOTER //
// ./src/firestore/reports.js